<template>
  <div class="users">
    <!-- HEADER WITH SWITCH AND NEW USER BUTTON -->
    <div class="users-header">
      <div class="types-toggles">
        <!-- <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === ''}"
          @click="userType = ''"
        >{{ $t('users-all') }}</span> -->
        <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === ''}"
          @click="userType = ''"
        >{{ $t('users-vas') }}</span>
        <!-- <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === 'isReporter'}"
          @click="userType = 'isReporter'"
        >{{ $t('users-reporters') }}</span> -->
        <!-- <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === 'allAdmins'}"
          @click="userType = 'allAdmins'"
        >{{ $t('users-admins') }}</span> -->
        <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === 'isWorker'}"
          @click="userType = 'isWorker'"
        >{{ $t('users-workers') }}</span>
        <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === 'groups' }"
          @click="userType = 'groups'"
          >{{ $t('users-groups') }}</span>
        <span
          class="type-toggle"
          :class="{ 'type-toggle--active': userType === 'isWorker-groups' }"
          @click="userType = 'isWorker-groups'"
          >{{ $t('users-workers-groups') }}</span>
      </div>
      <!-- <h2 class="desktop">Потребители</h2> -->
      <!-- ACTIVE/INACTIVE SWITCH -->
        <div class="switch-wrapper">
          <label
            class="switch-label"
            :class="{ 'switch-label-active': !showOnlyActive }"
            @click="showOnlyActive = false, getAllContent()"
          >{{ $t('inactive') }}</label>
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="showOnlyActive" @change="getAllContent()">
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            :class="{ 'switch-label-active': showOnlyActive }"
            @click="showOnlyActive = true, getAllContent()"
          >{{ $t('active') }}</label>
        </div>
      <!-- <div class="switch-wrapper">
        <label
          class="switch-label"
          :class="{ 'switch-label-active': !showUsers }"
          @click="showUsers = false"
        >Подизпълнители</label>
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="showUsers" />
            <span class="slider"></span>
          </label>
        </div>
        <label
          class="switch-label"
          :class="{ 'switch-label-active': showUsers }"
          @click="showUsers = true"
        >Потребители</label>
      </div> -->
      <!-- NEW USER BUTTON -->
      <transition name="slide-right-and-fade" mode="out-in">
        <template v-if="getUser.permissions.isSuperAdmin">
        <template v-if="userType === 'groups'">
          <button class="btn btn-new desktop" @click="isGroupModalOpened = true">
          <span class="tms">V</span>
          {{ $t('new-group') }}
        </button>
        </template>
        <template v-else>
          <button class="btn btn-new desktop" @click="openUsersModalToggle()">
            <span class="tms">V</span>
            {{ $t('new') }}
        </button>
        <!-- <div class="btns" v-else>
          <button class="btn btn-new btn-blue desktop" @click="isUserModalToggleOpened = 'employee'">
            <span class="tms">V</span>
            {{ $t('new-worker') }}
          </button>
          <button class="btn btn-new btn-green desktop" @click="isUserModalToggleOpened = 'worker'">
            <span class="tms">V</span>
            {{ $t('new-user') }}
          </button>
        </div> -->
      </template>
      </template>
        <!-- <template v-else>
          <button class="btn btn-new desktop" v-if="!showNewBtns" @click="showNewBtns = true">
            <span class="tms">V</span>
            {{ $t('new') }}
        </button>
        <div class="btns" v-else>
          <button class="btn btn-new btn-blue desktop" @click="isUserModalToggleOpened = 'employee'">
            <span class="tms">V</span>
            {{ $t('new-worker') }}
          </button>
          <button class="btn btn-new btn-green desktop" @click="isUserModalToggleOpened = 'worker'">
            <span class="tms">V</span>
            {{ $t('new-user') }}
          </button>
        </div>
      </template> -->
      </transition>
    </div>
    <template v-if="userType !== 'groups'">
    <!-- DESKTOP TABLE WITH USERS (ACTIVE AND INACTIVE) -->
    <div class="table-wrapper ">
      <table class="table">
        <tbody v-if="userType !== 'isWorker-groups'">
              <template v-if="searchFilter().length">

          <tr
            v-for="user of searchFilter()"
            :key="user._id"
            :class="{ 'inactive-row': !user.isActive}"
            @click="editUser(user)"
          >
            <td class="td-user-name hide-in-mobile">
              <span class="tms tms--brown" v-if="user.permissions.isWorker">z</span>
              <span class="tms tms--blue" v-else>y</span>
              <span>
                <strong>{{user.name}}</strong>
              </span>
            </td>
            <td class="hide-in-mobile">
              <template v-if="!user.permissions.isWorker">{{user.username}}</template>
            </td>
            <td class="hide-in-mobile">{{ user.group ? user.group.name : '' }}</td>
            <td class="hide-in-mobile" v-if="user.permissions.isWorker">
                  <!-- <span>Подизпълнител с <strong>{{ user.workerGroups.length }}</strong> групи</span> -->
                </td>
            <td class="td-right-align">
            <div class="user-mobile mobile">
                <span>
                  <strong>{{user.name}}</strong>
                </span>
              </div>
            <div class="user-permissions">
                <span
                  v-if="user.permissions.isSuperAdmin"
                  class="permission-indicator superadmin-indicator"
                >J</span>
                <span
                  v-if="user.permissions.isAdmin"
                  class="permission-indicator admin-indicator"
                >{{ $t('users-admin') }}</span>
                <span
                  v-if="user.permissions.isLeader"
                  class="permission-indicator reporter-indicator"
                >{{ $t('leader') }}</span>
                <span
                  v-if="user.permissions.isReporter"
                  class="permission-indicator reporter-indicator"
                >{{ $t('reporter') }}</span>
                <span
                  v-if="user.permissions.isWorker"
                  class="permission-indicator worker-indicator"
                >{{ $t('worker') }}</span>
                <span
                v-if="user.permissions.isEmployee"
                class="permission-indicator employee-indicator"
                >{{ $t('employee') }}</span>
              </div>
            </td>
          </tr>
            </template>
            <tr v-else>
              <td class="center">{{ $t("no-results") }}</td>
            </tr>
        </tbody>
        <tbody v-if="userType === 'isWorker-groups'">
              <template v-if="filteredGroups.length">

              <tr v-for="(wg, i) of filteredGroups"
                :class="{ 'inactive-row': !wg.isActive }" :key="`${wg._id}-${i}`" @click="editUser(wg.worker)">
                <td class="td-user-name hide-in-mobile">
                  <span class="tms tms--brown">1</span>
                  <span>
                    <strong>{{ wg.worker.name }}</strong> - <strong>{{ wg.name }}</strong>
                  </span>
                </td>
                <td class="hide-in-mobile">
                  <span>{{ wg.workersCount }} души</span>
                </td>
                <td class="td-right-align">
            <div class="user-mobile mobile">
                <span>
                  <strong>{{ wg.worker.name }}</strong> - <strong>{{ wg.name }}</strong>
                </span>
              </div>
            <div class="user-permissions">
                <span class="permission-indicator worker-group-indicator"
                >{{ $t('users-workers-group') }}</span>
              </div>
            </td>
              </tr>
          </template>
            <tr v-else>
              <td class="center">{{ $t("no-results") }}</td>
            </tr>
          </tbody>
      </table>
    </div>
    <!-- BUTTON NEW USER FOR MOBILE -->
    <footer class="modal-footer mobile">
      <transition name="slide-right-and-fade" mode="out-in">
        <div
          class="new-content-data-item-toggle-circle mobile"
          @click="openUsersModalToggle()"
        >
          <span class="tms">V</span>
        </div>
        <!-- <div v-else>
          <div
            class="new-content-data-item-toggle-circle btn-blue mobile"
            @click="isUserModalToggleOpened = 'employee'"
          >
            <span class="tms">V</span>
          </div>
          <div
            class="new-content-data-item-toggle-circle new-content-data-item-toggle-circle-2 btn-green mobile"
            @click="isUserModalToggleOpened = 'worker'"
          >
            <span class="tms">V</span>
          </div>
        </div> -->
      </transition>
    </footer>
  </template>
  <template v-if="userType === 'groups'">
      <div class="table-wrapper">
        <table class="table">
          <tbody>
          <template v-if="filteredGroups.length">
            <tr
              v-for="g of filteredGroups"
              :class="{ 'inactive-row': !g.isActive }"
              :key="g._id"
              @click="editGroup(g._id)"
            >
              <td class="td-user-name hide-in-mobile">
                <span class="tms tms--blue">0</span>
                <span>
                  <strong>{{ g.name }}</strong>
                </span>
              </td>
              <td class="hide-in-mobile">
                {{ g.users.length || 0 }} души
              </td>
              <td class="td-right-align">
            <div class="user-mobile mobile">
                <span>
                  <strong>{{ g.name }}</strong>
                </span>
              </div>
            <div class="user-permissions">
                <span class="permission-indicator group-indicator"
                >{{ $t('group') }}</span>
              </div>
            </td>
            </tr>
            </template>
            <tr v-else>
              <td class="center">{{ $t("no-results") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer
        class="modal-footer mobile"
        v-if="getUser.permissions.isSuperAdmin"
      >
        <div
          class="new-content-data-item-toggle-circle mobile"
          @click="isGroupModalOpened = true"
        >
          <span class="tms2">D</span>
        </div>
      </footer>
    </template>
    <!-- USER MODAL -->
    <!-- <transition name="fade">
      <appUserModal
        v-if="isUserModalToggleOpened"
        :idToEdit="idToEdit"
        :userMode="isUserModalToggleOpened === 'employee' ? true : false "
      />
    </transition> -->
    <!-- USER MODAL TOGGLE -->
    <transition name="fade">
      <UserModalToggle
        v-if="isUserModalToggleOpened"
        :idToEdit="idToEdit"
        :canToggle="true"
        :userMode="isUserMode"
      />
    </transition>
    <transition name="fade">
      <UserGroupModal
        v-if="isGroupModalOpened"
        :id="groupToEdit"
        @close="closeUserGroupModal"
      />
    </transition>
  </div>
</template>

<script>
import UserModalToggle from './shared/UserModalToggle';
// import UserModal from './shared/UserModal';
import UserGroupModal from "./shared/UserGroupModal";
import { mapGetters } from 'vuex';
export default {
  components: {
    // appUserModal: UserModal,
    UserGroupModal,
    UserModalToggle
  },
  data() {
    return {
      userType: '',
      showUsers: false,
      showNewBtns: false,
      showOnlyActive: true,
      isUserModalToggleOpened: '',
      isUserMode: '',
      isGroupModalOpened: false,
      idToEdit: '',
      groupToEdit: "",
      users: [],
      groups: [],
      workerGroups: [],
      search: ''
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ]),
    // Filtered by active
    filteredUsers() {
      if (this.userType === 'noPermissions') {
        return this.users.filter(u => {
          if (
            // !u.permissions.isSuperAdmin &&
            // !u.permissions.isAdmin &&
            // !u.permissions.isWorker &&
            // !u.permissions.isReporter
            u.permissions.isEmployee
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
      else if (this.userType.length) {
        return this.users.filter(u => {
          return u.permissions[this.userType] === true;
        });
      } else {
        return this.users.filter(u => {
          return u.permissions.isWorker === false;
        });
      }
    },
    filteredGroups() {
      let array = this.groups;
      if (this.userType === "isWorker-groups") array = this.workerGroups;
      return array
        .filter((g) => {
          return (
            g.name.toLowerCase().includes(this.search.toLowerCase()) ||
             // filter workers groups by worker name or workers group name
            (this.userType === "isWorker-groups" ? g.worker.name.toLowerCase().includes(this.search.toLowerCase()) : false)
          );
        })
        .sort((a, b) => { // sort workers groups by worker name alphabetical order
          if (this.userType === "isWorker-groups") {
            return a.worker.name.toLowerCase() < b.worker.name.toLowerCase() ? -1 : 1;
          }
        });
    },
  },
  watch: {
    userType(to) {
      if (to === "users") {
        this.getUsers();
      } else if (to === "groups") {
        this.getGroups();
      } else if(to == 'isWorker-groups') this.getWorkerGroups();
    },
  },
  methods: {
    openUsersModalToggle(){
      if(this.getUser.permissions.isSuperAdmin) {
      if(this.userType === 'isWorker'|| this.userType === 'isWorker-groups') this.isUserMode = false
      else this.isUserMode = true
      this.isUserModalToggleOpened = true
      } else {
        this.$snotify.error("Нямате нужните права да рекатирате потребители");

      }
    },
    // Filter users for searching by name
    searchFilter() {
      let filteredusers = this.filteredUsers;
      return filteredusers.filter(u => {
        return (
          u.name.toLowerCase().includes(this.search.toLowerCase()) ||
          u.username.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    editUser(u) {
      if (
        !this.getUser.permissions.isSuperAdmin
      ) {
        this.$snotify.error('Нямате нужните права да рекатирате потребители.');
        return;
      }
      if (
        u.permissions.isSuperAdmin &&
        !this.getUser.permissions.isSuperAdmin
      ) {
        this.$snotify.error(this.$t('users-no-permissions'));
        return;
      }
      this.idToEdit = u._id;
      this.isUserMode = u.permissions.isWorker ? false : true;
      this.isUserModalToggleOpened = true
    },
    getUsers() {
      this.$store.dispatch('startLoading');
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users?active=${this.showOnlyActive}`)
        .then(response => {
          this.users = [];
          this.users = response.data;
          this.$store.dispatch('stopLoading');
        });
    },
    getGroups() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group?active=${this.showOnlyActive}`)
        .then((response) => {
          this.groups = [];
          this.groups = response.data;
          this.$store.dispatch("stopLoading");
        });
    },
    getWorkerGroups() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group?workerGroups=true&active=${this.showOnlyActive}`)
        .then((response) => {
          this.workerGroups = [];
          this.workerGroups = response.data;
          this.$store.dispatch("stopLoading");
        });
    },
    editGroup(g) {
      if (!this.getUser.permissions.isSuperAdmin) {
        this.$snotify.error("Нямате права да редактирате групи.");
        return;
      }
      this.groupToEdit = g;
      this.isGroupModalOpened = true;
    },
    closeUserGroupModal(update) {
      this.isGroupModalOpened = false;
      this.groupToEdit = "";
      if (update) {
        this.getGroups();
      }
    },
    getAllContent() {
      this.getUsers();
      this.getGroups();
      this.getWorkerGroups();
    },
  },
  mounted() {
    this.getUsers();

    // this.$on('closeUserModal', result => {
    this.$on('closeUserToggleModal', result => {
      this.isUserModalToggleOpened = '';
      this.showNewBtns = false;
      this.idToEdit = '';
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.getAllContent()
      }
    });
  },
  updated() {
    // Handle search input
    this.$root.$on('sendSearchInput', data => {
      this.search = data;
      // console.log(this.search);
    });
  },
  destroyed() {
    // this.$off('closeUserModal');
    this.$off('closeUserToggleModal');
    this.$root.$off('sendSearchInput');
  }
};
</script>

<style scoped lang='scss'>
.users {
  padding: 10px 40px;
  overflow: hidden;
  width: 100%;
}
.users-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 10px;
}
.switch .slider {
  background-color: #9f0510;
}
.switch input:checked + .slider {
  background-color: #3b86ff;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}
td {
  width: 25%;
}
.table tr td:last-child {
  white-space: nowrap;
}
.table tr .td-widthless {
  width: 1%;
}
.td-right-align{
  text-align: right;
}
.td-user-name span {
  vertical-align: middle;
}
.td-user-name .tms,
.td-user-name .tms2 {
font-size: 30px;
  margin: 0 15px 0 4px;
}
.td-user-name .tms--blue{
 color:  #009CDB;
}
.td-user-name .tms--brown{
 color:  #443D39;
}

.inactive-row {
  background-color: #fddddd;
}
.inactive-row:hover {
  background-color: #f3c4c4;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}

.btn {
  width: initial;
  padding: 0 15px;
  white-space: nowrap;
}

.btn-blue {
  background-color: #03799e;
}

.btn-green {
  background-color: #89aa89;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .hide-in-mobile {
    display: none;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .users {
    padding: 10px 15px;
  }
  .users-header {
    flex-direction: column-reverse;
    gap: 10px;
    height: auto;
    justify-content: center;
  }
  .table-wrapper {
    overflow: auto;
  }
  .user-mobile {
    display: flex;
    justify-content: center;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  .user-permissions {
    display: flex;
    justify-content: center;
    padding-bottom: 0.5em;
  }
  .new-content-data-item-toggle-circle {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  .new-content-data-item-toggle-circle .tms {
    border-color: transparent;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle-2.mobile {
    bottom: 80px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .modal-footer {
    background-color: #fff;
    height: 75px;
    padding: 0px;
  }
}
</style>
